<template>
	<div class="contact-modal-component">
		<div class="heading">
			<h1 class="h2" v-html="content.heading" />
			<p class="p2" v-html="content.description" />
		</div>
		<div class="contact-section box">
			<div class="contact-left sm-16 md-8">
				<h2 class="left-heading h2" v-html="content.leftHeading" />
				<a
					class="left-phone h3"
					:aria-label="`Call Vanguard at ${content.leftPhone}`"
					:href="`tel:+1-${content.leftPhone}`"
				>
					<span v-html="content.leftPhone" />
				</a>
				<p class="left-details p1" v-html="content.leftDetails" />
			</div>
			<div class="contact-right sm-16 md-7 md-offset-1">
				<h2 class="right-heading h2" v-html="content.rightHeading" />
				<a
					class="p1"
					:aria-label="`E-mail Vanguard at ${content.rightEmail}`"
					:href="`mailto:${content.rightEmail}`"
					v-html="content.rightEmail"
				/>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * This component:
 *
 * - is intended to be opened inside the Faset modal component
 *
 * - is intended to source content from CAAS
 *
 * ## `content` object
 *
 * The content object is expecting the following properties:
 *
 * ```javascript
 * content: {
 * 	heading: "Order literature",
 * 	description: "Contact one of our representatives to order print copies of our literature.",
 * 	leftHeading: "Phone",
 * 	leftPhone: "800-997-2798",
 * 	leftDetails: "M-F 8:30 a.m. to 7 p.m., <span class='no-wrap'>Eastern time</span>",
 * 	rightHeading: "Email",
 * 	rightEmail: "advisor_services@vanguard.com"
 * }
 * ```
 */
export default {
	name: "ContactModal",
	props: {
		/**
		 * A content object containing properties described above.
		 */
		content: {
			type: Object,
			default: () => {
				return {
					heading: "",
					description: "",
					leftHeading: "",
					leftPhone: "",
					leftDetails: "",
					rightHeading: "",
					rightEmail: ""
				};
			}
		}
	}
};
</script>

<style scoped lang="scss">
.contact {
	&-section {
		margin-top: 64px;

		.h2 {
			margin-bottom: 20px;
		}

		.h3 {
			margin-bottom: 0;

			&.left-phone {
				color: $color--neutral-2;
				cursor: pointer;

				&:hover {
					border-bottom: 1px solid $color--neutral-2;
				}

				@include from-md() {
					pointer-events: none;

					&:hover {
						border-bottom: none;
					}
				}
			}
		}

		.left-details {
			padding-right: 16px;
		}
	}

	&-left,
	&-right {
		text-align: left;
	}

	&-right {
		a {
			&:hover {
				border-bottom: 1px solid $color--red-3;
			}
		}
	}
}

.no-wrap {
	white-space: nowrap;
}
</style>
